/* unplugin-vue-components disabled */import { render } from "./item-writing.vue?vue&type=template&id=408c5225"
import script from "./item-writing.vue?vue&type=script&lang=js"
export * from "./item-writing.vue?vue&type=script&lang=js"

import "./item-writing.vue?vue&type=style&index=0&id=408c5225&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__